export const USERS = () => `/users`;
